import { Box } from "@mui/material"

export default function CodeFormat({ value }: { value: string }) {
  return (
    <Box
      sx={{
        color: "GrayText",
        fontWeight: "500",
        padding: "10px 20px",
        fontSize: "14px",
      }}
    >
      <div>#{value}</div>
    </Box>
  )
}
